import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Button, Tooltip } from '@mui/material';

function PreviousDateButton({ selectedDate, setSelectedDate }) {
  return (
    <Tooltip arrow placement="top" title="Previous Day">
      <Button
        onClick={() => {
          const newDate = selectedDate.subtract(1, 'day');
          setSelectedDate(newDate);
        }}
        variant="outlined"
        size="small"
        sx={{
          minWidth: '0px',
          marginTop: '-5px',
          padding: '0 2px',
        }}>
        <ChevronLeftIcon />
      </Button>
    </Tooltip>
  );
}

export default PreviousDateButton;
